/** @jsx jsx */
import { useState, useCallback, useMemo } from 'react';
import { Column } from 'react-table';
import { css, jsx } from '@emotion/core';
import DataTable from 'components/organismos/DataTable/DataTable';
import { deleteById } from 'api/vacationMaster';
import useToastNotification from 'hooks/useToastNotification';
import { useVacationMaster } from './hooks';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import IconLabelButton from "components/molecules/IconLabelButton";
import { useHistory } from "react-router-dom";
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import { SubActionButton } from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import VacationDomain from 'domain/vacation';
import BlockUI from 'components/molecules/BlockUi';
import FormHeader from 'components/templates/FormHeader';
import FormPadding from 'components/atoms/Form/FormPadding';


const VacationMasterPage = () => {
  const history = useHistory();
  const { vacationList, setVacationList , blocking, setBlocking} = useVacationMaster();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedVacationMaster, setSelectedVacationMaster] = useState(VacationDomain.generateInitial());
  const { successNotification, errorNotification } = useToastNotification();

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((vacation : VacationDomain) => {
    setConfirmModalOpen(true);
    setSelectedVacationMaster(vacation);
  }, []);

  const deleteVacationMaster = useCallback(() => {
    setConfirmModalOpen(false);

    setBlocking(true);

    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

    deleteById(companyCode, selectedVacationMaster.holidayId).then((response:any) => {
      setVacationList(vacationList.filter(
        (vacation) => vacation.holidayId !== selectedVacationMaster.holidayId
      ));

      setBlocking(false);

      successNotification('削除しました。');
    }).catch((error) => {
      setBlocking(false);

      if (error.response && error.response.data && error.response.data.errors) {
        let msgError = '';

        error.response.data.errors.map((item: { defaultMessage: string; }) => {
          msgError += `${item.defaultMessage}\n`;
          return msgError;
        });

        errorNotification(msgError);
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
      }
    });
  }, [errorNotification, selectedVacationMaster.holidayId, setVacationList, successNotification, vacationList, setBlocking]);

  const columns: Array<Column<VacationDomain>> = useMemo(() => [
    {
      Header: () => null,
      id: 'actionButton',
      disableSortBy: true,
      Cell: (cell: { row: { isExpanded: boolean, original: VacationDomain } }) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <FlexBox>
              <FlexBoxItem 
                marginLeft="5px" 
                width="36px"
              >
                <SubActionButton 
                  action={0} 
                  text="編集" 
                  onClick={() => {
                    history.push(`/vacationMaster/edit/${cell.row.original.holidayId}`);
                  }} 
                />
              </FlexBoxItem>
              <FlexBoxItem margin="0 5px" width="36px">
                <SubActionButton 
                  action={1} 
                  text="削除" 
                  onClick={() => { openConfirmModal(cell.row.original); }} 
                />
              </FlexBoxItem>
            </FlexBox>
          </div>
        );
      }
    },
    {
      Header: '休暇コード',
      accessor: 'holidayCode'
    },
    {
      Header: '休暇名',
      accessor: 'holidayName'
    },
    // {
    //   Header: '休暇タイプ',
    //   accessor: 'holidayTypeLabel',
    // },
    // {
    //   Header: '色設定',
    //   id: 'holidayBgColor',
    //   Cell: (cell: { row :{original: VacationDomain }}) => (
    //     <div style={{
    //       backgroundColor: cell.row.original.holidayBgColor,
    //       color: cell.row.original.holidayForecolor,
    //       width: '50%',
    //       minHeight: '20px',
    //       borderRadius: '4px',
    //       textAlign: 'center',
    //       paddingTop: '6px',
    //       paddingBottom: '6px',
    //     }}
    //     >
    //       表示イメージ
    //     </div>
    //   ),
    // },
  ], [openConfirmModal, history]);

  return (
    <SidebarTemplate>
      <BlockUI blocking={blocking}>
        <FormHeader  title="休暇マスタ" />
        <FormContents customStyle={css({marginTop:'60px'})}>
          <FormPadding customStyle={css({paddingLeft:'8px'})}>
            <IconLabelButton
                onClick={() => history.push("/vacationMaster/create")}
                iconType="addCircle"
                text="追加"
              />
          </FormPadding>
          <div
            css={
              css` 
                table th:nth-of-type(1),
                table td:nth-of-type(1) {
                  width: 84px;
                }
              `
            }
          >
            <div 
              className="table-bordered table-padding" 
              style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px'}}
            >
              <DataTable
                columns={columns}
                data={vacationList}
                isGlobalFilter={true}
                minWidth="100%"
                // isHiddenPagination={true}
              />
            </div>
          </div>
          <ConfirmModal
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            title="休暇マスタを削除"
            content="休暇マスタを削除します。よろしいですか？"
            submitText="削除する"
            onSubmit={deleteVacationMaster}
            typeSubmit={'reject'}
          />
        </FormContents>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default VacationMasterPage;
